// extracted by mini-css-extract-plugin
export default {"wrapper":"SG2E87nLSBT_BT8eiUG3","mobile":"lIm2AwVf2_6txuX_s0CM","collapser":"lJMTBMhpzUY4FrBrXVTQ","menu":"chIvj0_dRKQenqzUwT1W"};